import React from "react";

/**
 * Official Quantum Results logo (wave + wordmark + tagline).
 * Use `variant="mark"` for the wave-only mark, `variant="full"` for full lockup.
 * Height controls scale (default: full-height 40px, mark 32px).
 */
export default function Logo({ variant = "full", className = "", alt = "Quantum Results" }) {
  const src = "/brand/quantum-results-logo.png";
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      draggable="false"
      loading="eager"
    />
  );
}
